import React from "react";
import Loader3 from "../sample/loader3";

const Loaderd = ({ wifiSpeed }) => {
    const data = [
        {
            txtInfo: `${wifiSpeed} `,
        },]
    return (
        <div className='home-container'>
                {data.map(item => <Loader3 {...item} />)}
         
        </div>
    )
}
export default Loaderd